var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05988 9.06571C6.10052 9.10636 6.13277 9.15462 6.15477 9.20773C6.17676 9.26084 6.18809 9.31776 6.18809 9.37524C6.18809 9.43273 6.17676 9.48965 6.15477 9.54276C6.13277 9.59587 6.10052 9.64413 6.05988 9.68478C6.01923 9.72542 5.97097 9.75767 5.91786 9.77966C5.86475 9.80166 5.80783 9.81299 5.75034 9.81299C5.69286 9.81299 5.63594 9.80166 5.58283 9.77966C5.52972 9.75767 5.48146 9.72542 5.44081 9.68478L1.06581 5.30977C1.02514 5.26914 0.992866 5.22089 0.970849 5.16778C0.948833 5.11467 0.9375 5.05774 0.9375 5.00024C0.9375 4.94275 0.948833 4.88582 0.970849 4.83271C0.992866 4.7796 1.02514 4.73134 1.06581 4.69071L5.44081 0.315712C5.52291 0.233619 5.63425 0.1875 5.75034 0.1875C5.86644 0.1875 5.97778 0.233619 6.05988 0.315712C6.14197 0.397805 6.18809 0.509147 6.18809 0.625243C6.18809 0.74134 6.14197 0.852682 6.05988 0.934775L1.99386 5.00024L6.05988 9.06571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.054f8f3d357900a1ccd30b6bcfdec594.svg";
export { ForwardRef as ReactComponent };